export const ERROR_GETTING_FILE_TYPES =
  'Error while getting the allowed file types';
export const ERROR_GETTING_LINKED_DOCUMENTS = 'Error getting linked documents';
export const ERROR_FILE_DESCRIPTION_REQUIRED = 'File description required';
export const ERROR_UPLOADING_DOCUMENT = 'Error while uploading the document';
export const ERROR_UPLOADING_DOCUMENT_EDIT =
  'Error while updating the document description';
export const ERROR_INVALID_FILE_TYPE = 'Invalid file type';
export const ERROR_INVALID_FILE_SIZE = 'Invalid file size';
export const SUCCESS_DOCUMENT_UPLOADED =
  'Supporting document saved successfully';
export const INFO_FILE_SIZE_TYPE = 'Upload file upto {0}MB of these types: {1}';
export const ERROR_FILE_SIZE = 'Upload file upto {0}MB';
export const ERROR_FILE_TYPE = 'Upload file of these types: {0}';
